class ImageQuestionStrategy {

    constructor(playScreenController, result) {
        this.playScreenController = playScreenController;
        this.result = result;

        this.mediaContainer = null;
        this.questionContainer = null;

        this.image = null;
        this.arrowUp = null;
        this.arrowDown = null;
        this.progressBar = null;
        this.timeout = null;
    }

    draw() {

        this.mediaContainer = $('#mediaContainer');
        this.questionContainer = $('#questionContainer');
        this.mediaContainer.slideDown();
        this.mediaContainer.css('text-align', 'center');
        this.mediaContainer.css('min-height', '200px');

        this.preloader = this.playScreenController.createPreloader(customIcons["QUESTION_MULTIMEDIA_IMAGE"]).appendTo(this.mediaContainer);
        this.preload();
    }

    preload() {
        if (!this.result.own_poll) {
            this.questionContainer.css('background-color', '#' + this.playScreenController.currentQuestion.category.color);
            $(".question-color-wrapper").css("background-color", hex2rgba(this.playScreenController.currentQuestion.category.color, 0.75));
        }
        this.questionContainer.css('min-height', 'calc(100% - 185px)');
        const mainContainer = $('#mainContainer');
        mainContainer.css('overflow', 'auto');
        $(".question-color-wrapper").show();
        setTimeout(this.load.bind(this), this.result.poll_end_resume ? 750 : 1500);
    }

    load() {

        const darkColor = this.result.own_poll ? this.result.own_poll.dark_color : this.playScreenController.currentQuestion.category.dark_color;

        this.arrowUp = $('<div>', {
            'class': 'media-arrow text-center',
            'html': '<i id="textUp" class="fa fa-angle-down fa-3x displayImgArrow" aria-hidden="true"></i>',
            'css': {
                'cursor': 'pointer',
                'color': '#' + darkColor,
                'position': 'relative'
            }
        }).prependTo(this.questionContainer);

        this.arrowDown = $('<div>', {
            'class': 'media-arrow text-center',
            'html': '<i id="textUp" class="fa fa-angle-up fa-3x displayImgArrow" aria-hidden="true"></i>',
            'css': {
                'cursor': 'pointer',
                'color': '#' + darkColor,
                'position': 'relative'
            }
        }).prependTo(this.questionContainer);

        this.image = $('<img>', {
            'class': 'img-responsive',
            'css': {
                'margin': 'auto'
            }
        }).appendTo(this.mediaContainer);

        // Safety timeout
        this._safetyTimeout = setTimeout(() => {
             if(this.preloader) this.preloader.hide();
        }, 5000);

        this.image.on('load', function(){
            var currentImgHeight = $(this).height();

            var imageConHeight = ($(window).height() - 207)*0.8;
            if(currentImgHeight < imageConHeight){
                imageConHeight = currentImgHeight;
            }

            $("#mediaContainer").css("height", imageConHeight + "px");

            $(window).resize(function () {
                imageConHeight = ($(this).height() - 207)*0.8;
                if(currentImgHeight < imageConHeight) {
                    imageConHeight = currentImgHeight;
                }
                $("#mediaContainer").css("height", imageConHeight + "px");
            });
        });

        this.image.attr('src', this.playScreenController.currentQuestion.multimedia);

        this.progressBar = $('<div>', {
            'class': 'multimedia-progress-bar',
            'html': '<div>'
        }).appendTo(this.mediaContainer);

        // Configurar componentes
        this.arrowUp.hide();
        this.hideAnswerButtonTexts();

        // Eventos para los componentes
        let ms = world.multimedia_image_show_time;
        this.timeout = setTimeout(this.startTime.bind(this), this.result.poll_end_resume ? 0 : ms);
        // this.timeout is used in startTime() to clearTimeout on early skip
        this.arrowDown.on('click', this.startTime.bind(this));
        this.arrowUp.on('click', this.showImage.bind(this));

        // Start progress bar
        $('.multimedia-progress-bar div').animate({
            'width': '100%'
        }, ms, 'linear');

        this.image.on('load error', () => {
            this.preloader.hide();
        });

        $('body').addClass('stop-scrolling');

        $('img').bind('load', function () {
            calculateMediaContentSize(this, 'image')
        });

    };

    startTime() {
        clearTimeout(this.timeout);
        this.arrowDown.off('click');
        this.arrowDown.on('click', this.hideImage.bind(this));

        this.hideImage();
        $(".question-color-wrapper").hide();
        this.showAnswerButtonTexts();
        this.progressBar.hide();

        if (!this.result.own_poll) {
            this.playScreenController.startTimer(this.result);
        } else {
            this.playScreenController.startTimerPoll(this.result);
        }
    }

    hideImage() {
        if(this.preloader) {
            this.preloader.hide();
        }
        this.mediaContainer.slideUp();
        this.arrowUp.show();
        this.arrowDown.hide();
        $('body').removeClass('stop-scrolling');
    }

    showImage() {
        this.mediaContainer.slideDown();
        this.arrowUp.hide();
        this.arrowDown.show();
        $('body').addClass('stop-scrolling');
    }

    hideAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(' ');
        });
    }

    showAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(elem.attr('data-answer'));
        });
    }

    cancel() {
        clearTimeout(this.timeout);
        clearTimeout(this._safetyTimeout);
        if (this.image) this.image.off('load error');
    }

}